import * as actions from './actions';
import * as reducers from './reducers';
import sagas from './sagas';
export { default as APIsRoute } from './APIsRoute';

export default {
	actions,
	reducers,
	sagas
};
